import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { EntryItem } from 'src/app/model/common/entry-item';
import { UpperCasePipe, DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from '@openng/optimus-ui/tooltip';

@Component({
  selector: 'app-log-entry',
  templateUrl: './log-entry.component.html',
  styleUrls: ['./log-entry.component.scss'],
  imports: [UpperCasePipe, DatePipe, TranslatePipe, Tooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogEntryComponent {
  readonly entry = input<EntryItem>();
  readonly canEdit = input(false);
  readonly canDelete = input(false);

  readonly editEvent = output<any>();
  readonly deleteEvent = output<any>();
}
